<template>
  <layout-component>
    <div class="banner banner-contact">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <h1 v-if="page" class="left-bullet">{{ $i18n.locale === 'en' ? (page.title_en || page.title) : page.title }}</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="main-policy">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center mb-3 mb-lg-5">
          <div class="col-md-8">
            <div v-if="page" v-html="$i18n.locale === 'en' ? (page.body_en || page.body) : page.body"></div>
          </div>
        </div>
      </div>
    </div>
  </layout-component>
</template>

<script>
export default {
  name: 'LegalPage',
  data() {
    return { page: null }
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios.get('/pages/legal-policy').then(({ data }) => {
      next(vm => { vm.page = data })
    }).catch(() => next(vm => { vm.page = null }))
  }
}
</script>
